import React from "react";
import { loadModules } from "esri-loader";
import { useEffect, useState, useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  ArcElement,
} from 'chart.js';
import { Bar, PolarArea } from 'react-chartjs-2';
import '@arcgis/core/assets/esri/themes/light/main.css';
import '/components/services/map/Map.css';

// FeatureLayer : const list features for SIRET Number
const lstFeatures = [];




const Map = () => {







  /* 
  ** Scroll Movement between map and feature table
  */
  const [currentSection, setCurrentSection] = useState(1);
  const nextSectionRef = useRef(null);
  const previousSectionRef = useRef(null);

  const handleNextSection = () => {
    setCurrentSection(currentSection + 1);
    nextSectionRef.current.scrollIntoView({ behavior: 'smooth' });
  };
  const handlePreviousSection = () => {
    setCurrentSection(currentSection - 1);
    scrollToTopSmoothly();
  };

  const scrollToTopSmoothly = () => {
    const currentPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

    if (currentPosition > 0) {
      window.requestAnimationFrame(scrollToTopSmoothly);
      window.scrollTo(0, currentPosition - currentPosition / 12); // Ajustez la valeur "8" pour contrôler la vitesse de défilement
    }
  };



  useEffect(() => {

    loadModules([
      "esri/config",
      "esri/Map",
      "esri/views/SceneView",
      "esri/layers/SceneLayer",
      "esri/layers/FeatureLayer",
      "esri/Graphic",
      "esri/geometry/Point",
      "esri/renderers/UniqueValueRenderer",
      "esri/layers/GraphicsLayer",
      "esri/widgets/Sketch/SketchViewModel",
      "esri/widgets/Search",
      "esri/layers/CSVLayer",
      "esri/layers/GeoJSONLayer",
      "esri/layers/GraphicsLayer",
      "esri/widgets/Slider",
      "esri/geometry/geometryEngine",
      "esri/core/promiseUtils",
      "esri/rest/support/Query",
      "esri/widgets/FeatureTable",
      "esri/core/reactiveUtils",
      "esri/layers/support/FeatureFilter",
      "esri/widgets/LayerList",

    ]).then(([esriConfig, Map, SceneView, SceneLayer, FeatureLayer, Graphic, Point, UniqueValueRenderer, GraphicsLayer, SketchViewModel, Search, CSVLayer, GeoJSONLayer, Slider, geometryEngine, promiseUtils, Query, reactiveUtils, FeatureTable, FeatureFilter, LayerList]) => {

      esriConfig.apiKey = import.meta.env.VITE_REACT_APP_MAP_API_KEY;


      /**
       *  Layers of the map
       */

      // Surface Layer 1

      const surfaceLayer1 = new SceneLayer({
        url: "https://elevation3d.arcgis.com/arcgis/rest/services/WorldElevation3D/Terrain3D/ImageServer"
      });


      // Surface Layer 2
      const surfaceLayer2 = new FeatureLayer({
        url: "https://tiles.arcgis.com/tiles/d3voDfTFbHOCRwVR/arcgis/rest/services/MNT_IDF/ImageServer"
      });

      // Surface Layer 3
      const surfaceLayer3 = new FeatureLayer({
        url: "https://services5.arcgis.com/bczlEqNYBiehXz06/arcgis/rest/services/companies123/FeatureServer/layers/company"
      });

      // Surface Layer 4
      const surfaceLayer4 = new FeatureLayer({
        //url: "https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/companies_financial_data_vue/FeatureServer/0",
        url: "https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/companies_data_updated/FeatureServer",

        popupEnabled: true,
        outFields: ["*"],
        minScale: 10000,  // Définir l'échelle maximale à laquelle la couche sera visible
        maxScale: 1,
        renderer: {
          type: "class-breaks",
          field: "chiffre_d_affaires",
          defaultSymbol: {
            type: "simple-marker",
            color: "blue",
            size: 5
          },
          classBreakInfos: [
            {
              minValue: -Infinity,
              maxValue: 100000,
              symbol: {
                type: "simple-marker",
                color: "yellow",
                size: 5
              }
            },
            {
              minValue: 100000,
              maxValue: 500000,
              symbol: {
                type: "simple-marker",
                color: "orange",
                size: 5
              }
            },
            {
              minValue: 500000,
              maxValue: +Infinity,
              symbol: {
                type: "simple-marker",
                color: "red",
                size: 5
              }
            }
          ]
        }
      });

      const template1 = {

        title: "Companies",
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "creationDate",
                label: "Creation date"
              },
              {
                fieldName: "name",
                label: "Name"
              },
              {
                fieldName: "address",
                label: "Address"
              },
              {
                fieldName: "postCode",
                label: "Post code"
              },
              {
                fieldName: "siretNumber",
                label: "SIRET Number"
              },
              {
                fieldName: "mainActivityCode",
                label: "Main activity code"
              },
              {
                fieldName: "date_cloture_exercice",
                label: "Accounts closing date"
              },
              {
                fieldName: "chiffre_d_affaires",
                label: "Revenue"
              },
              {
                fieldName: "resultat_net",
                label: "Net profit"
              },
              {
                fieldName: "autonomie_financiere",
                label: "Financial autonomy"
              },
              {
                fieldName: "ratio_de_liquidite",
                label: "Cash ratio"
              },
            ]
          }
        ]
      };

      surfaceLayer4.popupTemplate = template1;

      // const financeFeatureLayer = new FeatureLayer({
      //   url: 'http://localhost:8282/companies',
      //   outFields: ['*'], // Spécifiez les champs que vous souhaitez récupérer
      // });

      //   const surfaceLayer5  = new FeatureLayer({
      //   url:"https://services.arcgis.com/wLDmHsvxROjaiPKt/arcgis/rest/services/arrondissements_paris/FeatureServer",
      //   renderer: {
      //     type: "simple", // Type de rendu simple
      //     symbol: {
      //       type: "simple-fill", // Type de symbole de remplissage simple
      //       color: [125, 167, 163, 0.8], // Nouvelle couleur de remplissage de la couche (RGB avec opacité)
      //       outline: {
      //         // Optionnel : Définir les propriétés de la bordure
      //         color: [255, 255, 255, 1], // Couleur de la bordure (blanc dans cet exemple)
      //         width: 1 // Largeur de la bordure (1 pixel dans cet exemple)
      //       }
      //     }
      //   }
      // });

      const surfaceLayer6 = new FeatureLayer({
        // url: "https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/polygon_dans_companies_Victory/FeatureServer/0",
        //url: "https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/Jointure_companies_data/FeatureServer/0",
        // url:"https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/test_jointure_proche/FeatureServer",
        // url:"https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/test_jointure_proche1/FeatureServer",
        // url: "https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/Left_join_companies_data/FeatureServer",
        url: "https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/Inner_join_intersect/FeatureServer/",
        // url: "https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/Left_join_distance_7/FeatureServer/",
        popupEnabled: true,
        outFields: ["chiffre_d_affaires"],
        renderer: {
          type: "class-breaks",
          field: "chiffre_d_affaires",
          defaultSymbol: {
            type: "simple-fill",
            color: "blue",
            // color:"white",
            // color: [125, 167, 163, 0.5],
            reflectance: 30
          },
          classBreakInfos: [
            {
              minValue: -Infinity,
              maxValue: 10000,
              symbol: {
                type: "simple-fill",
                color: "yellow",
                // color: [253, 197, 0, 0.2],
                // color: [150, 200, 195, 0.2],
                // color: [125, 167, 163, 0.2],
                reflectance: 30
              }
            },
            {
              minValue: 10000,
              maxValue: 50000,
              symbol: {
                type: "simple-fill",
                color: "orange",
                // color: [125, 167, 163, 0.5],
                // color: [100, 140, 135, 0.5],
                reflectance: 30
              }
            },
            {
              minValue: 50000,
              maxValue: +Infinity,
              symbol: {
                type: "simple-fill",
                color: "red",

                // color: [34, 87, 36, 1],
                reflectance: 30
              }
            }
          ]
        }
      });


      const template2 = {

        title: "Companies",
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "creationDate",
                label: "Creation date",
                format: {
                  dateFormat: "short-date"
                }
              },
              {
                fieldName: "name",
                label: "Building'name",
                visible: false

              },
              {
                fieldName: "name_1",
                label: "Companie's name",
              },
              {
                fieldName: "address",
                label: "Address"
              },
              {
                fieldName: "postCode",
                label: "Post code"
              },
              {
                fieldName: "sirenNumber",
                label: "SIREN Number "
              },
              {
                fieldName: "siretNumber",
                label: "SIRET Number "
              },
              {
                fieldName: "mainActivityName",
                label: "Activity "
              },
              {
                fieldName: "date_cloture_exercice",
                label: "Accounts closing date",
                format: {
                  dateFormat: "short-date"
                }
              },
              {
                fieldName: "chiffre_d_affaires",
                label: "Revenue",
                format: {
                  digitSeparator: true,

                }
              },
              {
                fieldName: "resultat_net",
                label: "Net profit",
                format: {
                  digitSeparator: true,

                }
              },
              {
                fieldName: "autonomie_financiere",
                label: "Financial autonomy",
                format: {
                  digitSeparator: true,
                  places: 0
                }
              },
              {
                fieldName: "ratio_de_liquidite",
                label: "Cash ratio",
                format: {
                  digitSeparator: true,
                  places: 0
                }
              },
            ]
          }
        ]

      };

      const queryCA = surfaceLayer6.createQuery();
      queryCA.geometry;
      queryCA.returnGeometry = false;
      queryCA.outStatistics = [
        {
          statisticType: "sum",
          onStatisticField: "chiffre_d_affaires",
          outStatisticFieldName: "sum_chiffre_d_affaires",
        },
      ];

      surfaceLayer6.queryFeatures(queryCA).then((result) => {
        const sumChiffreDAffaires = result.features[0].attributes.sum_chiffre_d_affaires;
        console.log("Somme des chiffres d'affaires :", sumChiffreDAffaires);
      });

      surfaceLayer6.popupTemplate = template2;




      const surfaceLayer7 = new SceneLayer({
        url: "https://basemaps3d.arcgis.com/arcgis/rest/services/OpenStreetMap3D_Buildings_v1/SceneServer",
        renderer: {
          type: "simple",
          symbol: {
            type: "mesh-3d",
            symbolLayers: [{
              type: "fill",
              material: {
                color: [255, 255, 255, 0.2],
                // color: [125, 167, 163, 0.2],
                metalness: 1.0,
                reflectance: 30
              },
              outline: { color: [0, 0, 0, 0.25] },
              edges: { type: "solid", color: [0, 0, 0, 0.6], size: 1.5 }
            }]
          }
        },
        popupEnabled: true // Rend le layer non cliquable
      });

      // Définir les éléments à masquer
      const elementsAMasquer = ["Tour Eiffel", "Palais de Chaillot", "Maison de la Radio et de la Musique", "Hyatt Regency Paris Etoile", "Arc de Triomphe", "Hôtel des Invalides", "Église du Dôme (tombeau de Napoleon Ier)", "Cathédrale Saint-Louis des Invalides"]; // Remplacez par les noms des éléments à masquer

      // Créer le filtre attributaire pour exclure les éléments
      const attributFilter = {
        where: `NOT (name LIKE '%${elementsAMasquer[0]}%' 
          OR name LIKE '%${elementsAMasquer[1]}%' 
          OR name LIKE '%${elementsAMasquer[2]}%'
          OR name LIKE '%${elementsAMasquer[3]}%'
          OR name LIKE '%${elementsAMasquer[4]}%'
          OR name LIKE '%${elementsAMasquer[5]}%'
          OR name LIKE '%${elementsAMasquer[6]}%'
          OR name LIKE '%${elementsAMasquer[7]}%')` // Utilisez l'attribut approprié pour le filtre
      };


      // Appliquer le filtre attributaire à la couche
      surfaceLayer7.definitionExpression = attributFilter.where;


      // Building Layer

      const cyberCityBatiments = new SceneLayer({
        url: "https://tiles.arcgis.com/tiles/d3voDfTFbHOCRwVR/arcgis/rest/services/Batiments_CyberCity/SceneServer",
        renderer: {
          type: "simple",
          symbol: {
            type: "mesh-3d",
            symbolLayers: [{
              type: "fill",
              material: {
                type: "mesh-physical",
                color: [255, 255, 255, 0.25],
                colorMixMode: "tint"
              },
              outline: { color: [0, 0, 0, 0.5] },
              edges: { type: "solid", color: [0, 0, 0, 0.6], size: 1.5 }
            }]
          }
        },
        popupEnabled: false // Rend le layer non cliquable
      });

      //Building Layer
      const batimentsProcedurauxBatiments = new SceneLayer({
        url: "https://tiles.arcgis.com/tiles/d3voDfTFbHOCRwVR/arcgis/rest/services/Batiments_Proceduraux_Paris/SceneServer",
        renderer: {
          type: "simple",
          symbol: {
            type: "mesh-3d",
            symbolLayers: [{
              type: "fill",
              material: {
                color: [255, 255, 255, 0.25],
                colorMixMode: "tint",
                colorMixAmount: 0.5,
                metallic: 0.8,
                roughness: 0.2,
                reflectance: 2
              },
              outline: { color: [0, 0, 0, 0.5] },
              edges: { type: "solid", color: [0, 0, 0, 0.6], size: 1.5 }
            }]
          }
        },
        popupEnabled: false // Rend le layer non cliquable
      });



      // Building Layer
      const batimentsRemarquablesBatiments = new SceneLayer({
        url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/arcgis/rest/services/Batiments_Remarquables_3D/SceneServer/layers/0",
        renderer: {
          type: "simple",
          symbol: {
            type: "mesh-3d",
            symbolLayers: [{
              type: "fill",
              material: { color: [245, 188, 61, 0.5] },
              outline: { color: [0, 0, 0, 0.5] },
              edges: { type: "solid", color: [0, 0, 0, 0.6], size: 1.5 }
            }]
          }
        }
      });

      // Building Layer
      const batimentsProcedurauxPetiteCouronneBatiments = new SceneLayer({
        url: "https://tiles.arcgis.com/tiles/d3voDfTFbHOCRwVR/arcgis/rest/services/Batiments_Proceduraux_Petite_Couronne/SceneServer"
      });

      const geojsonlayer = new GeoJSONLayer({
        url: "https://gladtofindu-back-nodejs-companies.onrender.com/featurelayers",
        popupEnabled: true,
        outFields: ["*"],
        minScale: 10000,  // Définir l'échelle maximale à laquelle la couche sera visible
        maxScale: 1,
        renderer: {
          type: "class-breaks",
          field: "resultat_net",
          defaultSymbol: {
            type: "simple-marker",
            color: "blue",
            size: 5
          },
          classBreakInfos: [
            {
              minValue: -Infinity,
              maxValue: 10000,
              symbol: {
                type: "simple-marker",
                color: "yellow",
                size: 5
              }
            },
            {
              minValue: 10000,
              maxValue: 50000,
              symbol: {
                type: "simple-marker",
                color: "orange",
                size: 5
              }
            },
            {
              minValue: 50000,
              maxValue: +Infinity,
              symbol: {
                type: "simple-marker",
                color: "red",
                size: 5
              }
            }
          ]
        }

      });

      const template3 = {

        title: "Companies",
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "creationDate",
                label: "Creation date"
              },
              {
                fieldName: "name 1",
                label: "Name"
              },
              {
                fieldName: "address",
                label: "Address"
              },
              {
                fieldName: "postCode",
                label: "Post code"
              },
              {
                fieldName: "sirenNumber",
                label: "SIREN Number "
              },
              {
                fieldName: "siretNumber",
                label: "SIRET Number "
              },
              {
                fieldName: "date_cloture_exercice",
                label: "Accounts closing date"
              },
              {
                fieldName: "chiffre_d_affaires",
                label: "Revenue"
              },
              {
                fieldName: "resultat_net",
                label: "Net profit"
              },
              {
                fieldName: "autonomie_financiere",
                label: "Financial autonomy"
              },
              {
                fieldName: "ratio_de_liquidite",
                label: "Cash ratio"
              },
            ]
          }
        ]

      };

      geojsonlayer.popupTemplate = template3;




      /**
       *  Map creation
       */

      const map = new Map({
        basemap: "arcgis-light-gray",
        ground: "world-elevation",
        layers: [surfaceLayer6, surfaceLayer7, batimentsRemarquablesBatiments]
        //layers: [surfaceLayer6,surfaceLayer4, cyberCityBatiments, batimentsProcedurauxBatiments, batimentsRemarquablesBatiments]
        //layers: [geojsonlayer]

        //layers: [surfaceLayer6, batimentsProcedurauxBatiments, cyberCityBatiments, batimentsRemarquablesBatiments]
        //layers: [cyberCityBatiments,batimentsProcedurauxBatiments,batimentsRemarquablesBatiments]
        //layers: [surfaceLayer7,batimentsRemarquablesBatiments]
      });



      /**
        *  Sceneview creation
      */

      const view = new SceneView({
        container: "viewDiv",
        map: map,
        camera: {
          position: [3.2930, 49.8450, 10000000],
          heading: 0,
          tilt: 0
          // position: [2.3077897, 48.8498227, 140],
          // heading: -45,
          // tilt: 90
        },
        qualityProfile: "high",
        environment: {
          lighting: {
            //directShadowsEnabled: true,
            ambientOcclusionEnabled: true,
          },
          atmosphere: {
            quality: "high"
          }
        }
      });





      /**
      *  3D objects add by clicking on the button
      */

      // Add 3D object to the map 
      const graphicsLayer = new GraphicsLayer({
        elevationInfo: { mode: "on-the-ground" }
      });

      view.map.add(graphicsLayer);

      const tentBtn = document.getElementById("tent");
      const canoeBtn = document.getElementById("canoe");

      view
        .when(() => {
          // This sample uses the SketchViewModel to add points to a
          // GraphicsLayer. The points have 3D glTF models as symbols.
          const sketchVM = new SketchViewModel({
            layer: graphicsLayer,
            view: view
          });

          tentBtn.addEventListener("click", () => {
            // reference the relative path to the glTF model
            // in the resource of an ObjectSymbol3DLayer
            sketchVM.pointSymbol = {
              type: "point-3d",
              symbolLayers: [
                {
                  type: "object",
                  resource: {
                    href: "https://developers.arcgis.com/javascript/latest/sample-code/import-gltf/live/tent.glb"
                  }
                }
              ]
            };
            sketchVM.create("point");
            tentBtn.classList.add("esri-button--secondary");
          });

          canoeBtn.addEventListener("click", () => {
            // reference the relative path to the glTF model
            // in the resource of an ObjectSymbol3DLayer
            sketchVM.pointSymbol = {
              type: "point-3d",
              symbolLayers: [
                {
                  type: "object",
                  resource: {
                    href: "https://developers.arcgis.com/javascript/latest/sample-code/import-gltf/live/canoe.glb"
                  }
                }
              ]
            };

            sketchVM.create("point");
            canoeBtn.classList.add("esri-button--secondary");
          });

          sketchVM.on("create", (event) => {
            if (event.state === "complete") {
              sketchVM.update(event.graphic);
              //deactivateButtons();
            }
          });
        })
        .catch(console.error);


      /**
        * Query Statistics (beginning)
        */

      let statistics;
      let sketchGeometry; // Variable pour stocker la géométrie du polygone dessiné
      const query = surfaceLayer6.createQuery();
      query.geometry = sketchGeometry;
      query.outStatistics = [
      ];

      // Utilisez SketchViewModel pour dessiner des polygones qui serviront à effectuer la requête
      const sketchViewModel = new SketchViewModel({
        layer: graphicsLayer,
        view: view,
        polygonSymbol: {
          type: "polygon-3d",
          symbolLayers: [
            {
              type: "fill",
              material: {
                color: [255, 255, 255, 0.8]
              },
              outline: {
                color: [211, 132, 80, 0.7],
                size: "10px"
              }
            }
          ]
        }
      });



      sketchViewModel.on("create", (event) => {
        if (event.state === "complete") {
          sketchGeometry = event.graphic.geometry;
          performQuery();
        }
      });

      // Fonction pour effectuer la requête lorsque le bouton est cliqué
      function performQuery() {
        const query = surfaceLayer6.createQuery();
        query.geometry = sketchGeometry;
        query.outStatistics = [

          {
            onStatisticField:
              "CASE WHEN (chiffre_d_affaires >= '0') THEN chiffre_d_affaires ELSE 0 END",
            outStatisticFieldName: "chiffre_d_affaires",
            statisticType: "sum"
          },
          {
            onStatisticField:
              "CASE WHEN (chiffre_d_affaires <= 500000) THEN 1 ELSE 0 END",
            outStatisticFieldName: "companies_revenue_under_500000",
            statisticType: "sum"
          },
          {
            onStatisticField:
              "CASE WHEN (chiffre_d_affaires >= 500000) THEN 1 ELSE 0 END",
            outStatisticFieldName: "companies_revenue_over_500000",
            statisticType: "sum"
          },

        ];


        surfaceLayer6.queryFeatures(query)
          .then((response) => {
            statistics = response.features[0].attributes;
            setCompanies_count_under_500k(response.features[0].attributes.companies_revenue_under_500000)
            setCompanies_count_over_500k(response.features[0].attributes.companies_revenue_over_500000)
            setRevenue_global_chart(response.features[0].attributes.chiffre_d_affaires)
            console.log("Statistics", response.features[0].attributes);

          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }

      // Code pour le bouton qui déclenche la sélection
      const selectButton = document.getElementById("selectButton");
      selectButton.addEventListener("click", () => {
        sketchViewModel.create("polygon");
        setChartDisplay("block");
      });


      // Fonction pour effacer le contenu affiché de la sélection
      function clearSelectionResult() {
        setCompanies_count_under_500k("");
        setCompanies_count_over_500k("");
        setRevenue_global_chart("");
        setChartDisplay("none");

      }

      // Code pour le bouton qui efface la requête
      const clearButton = document.getElementById("clearButton");
      clearButton.addEventListener("click", () => {
        // Réinitialisez la géométrie du polygone dessiné
        sketchGeometry = null;

        // Effacez les graphiques existants dans la couche graphicsLayer
        graphicsLayer.removeAll();

        // Effacez le contenu affiché de la sélection
        clearSelectionResult();

      });



      /**
      * Query Statistics (ending)
      */


      /**
       *  3D objects initialization at he beginning of the map
       */

      //Create a GraphicsLayer to hold the glTF model
      const graphicsLayer1 = new GraphicsLayer();


      const graphic = new Graphic({
        geometry: {
          type: 'point',
          x: 2.299293008305132,
          y: 48.85903179141001,
          z: 250, // Elevation from ground
        },
        symbol: {
          type: 'point-3d',
          symbolLayers: [
            {
              type: 'object',
              resource: {
                href: '/3dmodels/Low-Poly_airshipV9.glb'
              }
            }
          ],

        }
      });


      graphicsLayer1.add(graphic);

      view.map.add(graphicsLayer1);

      /**
      *  Feature Table(Beginning)
      */

      // Get references to div elements for toggling table visibility
      const appContainer = document.getElementById("appContainer");
      const tableContainer = document.getElementById("tableContainer");
      const tableDiv = document.getElementById("tableDiv");

      // When view is ready, find feature layer and set title and outFields
      view.when(() => {

        // Get references to div elements for toggling table visibility
        const appContainer = document.getElementById("appContainer");
        const tableContainer = document.getElementById("tableContainer");
        const tableDiv = document.getElementById("tableDiv");

        // Create FeatureTable
        const featureTable = new FeatureTable({
          view: view, // make sure to pass in view in order for selection to work
          layer: surfaceLayer6,
          tableTemplate: {
            // autocasts to TableTemplate
            columnTemplates: [
              {
                type: "field",
                fieldName: "creationDate",
                label: "Creation Date",
                visible: true,
                format: {
                  dateFormat: "short-date"
                }
              },
              {
                type: "field",
                fieldName: "mainActivityCode",
                label: "Main activity code",
              },
              {
                type: "field",
                fieldName: "mainActivityName",
                label: "Main activity name",
              },
              {
                type: "field",
                fieldName: "name 1",
                label: "Name",
                visible: true,
              },
              {
                type: "field",
                fieldName: "address",
                label: "Address",
                //   direction: "asc",
                //   initialSortPriority: 1,
              },
              {
                type: "field",
                fieldName: "postCode",
                label: "Post code",
                //   direction: "asc",
                //   initialSortPriority: 0,
              },
              {
                type: "field",
                fieldName: "siretNumber",
                label: "Siret number",
              },
              {
                type: "field",
                fieldName: "date_cloture_exercice",
                label: "Accounts closing date",
                visible: true,
                format: {
                  dateFormat: "short-date"
                }
              },
              {
                type: "field",
                fieldName: "chiffre_d_affaires",
                label: "Revenue",
                format: {
                  digitSeparator: true,

                }
              },
              {
                type: "field",
                fieldName: "resultat_net",
                label: "Net profit",
                format: {
                  digitSeparator: true,

                }
              },
              {
                type: "field",
                fieldName: "autonomie_financiere",
                label: "Financial autonomy",
                format: {
                  digitSeparator: true,
                  places: 2,
                  round: true
                }
              },
              {
                type: "field",
                fieldName: "ratio_de_liquidite",
                label: "Cash ratio",
                format: {
                  digitSeparator: true,
                  places: 2,
                  round: true
                }
              }
            ]
          },
          container: tableDiv
        });


        // Get the FeatureLayer's layerView and listen for the table's selection-change event
        // Here I'm maintaining a list of features for use elsewhere
        //let lstFeatures = [];
        featureTable.on("selection-change", function (changes) {
          var idxItem = 1;
          // If the selection is removed, remove the feature from the array
          changes.removed.forEach(function (item) {
            const data = lstFeatures.find(function (data) {
              return data.feature === item.feature;
            });
            if (data) {
              lstFeatures.splice(lstFeatures.indexOf(data), 1);
            }
          });

          // If the selection is added, push all added selections to array
          changes.added.forEach(function (item) {
            const feature = item.feature;
            lstFeatures.push({
              feature: feature
            });
            console.log(lstFeatures)
          });
        });

        /**
              *  Feature Table (Ending)
              */



        /**
         *  GOTO Search Widget top right of the map
         */

        const searchWidget = new Search({
          view: view,
          allPlaceholder: "District or Senator",
          includeDefaultSources: false,
          sources: [
            {
              layer: surfaceLayer6,
              searchFields: ["name_1", "siretNumber", "sirenNumber", "address"],
              displayField: "name_1",
              exactMatch: false,
              outFields: ["name_1", "siretNumber"],
              name: "Companies",
              placeholder: "Find by address, siret or name",
              enableSuggestions: true,
              zoomScale: 500000

            },

          ]
        });

        // The following snippet uses the Search widget but can be applied to any
        // widgets that support the goToOverride property.
        searchWidget.goToOverride = function (view, goToParams) {
          goToParams.target.scale = 5000;
          goToParams.options.duration = 5000;
          goToParams.options.easing = customEasing;
          return view.goTo(goToParams.target, goToParams.options);
        };

        // Add the search widget to the top right corner of the view
        view.ui.add(searchWidget, {
          position: "top-right"
        });


        /**
     *  GOTO Camera movement animation
     */

        function shiftCamera(deg) {
          const camera = view.camera.clone();
          camera.position.longitude += deg;
          return camera;
        }

        function catchAbortError(error) {
          if (error.name != "AbortError") {
            console.error(error);
          }
        }


        // function customEasing(t) {
        //   return (
        //     1 -
        //     Math.abs(Math.sin(-1.7 + t * 4.5 * Math.PI)) * Math.pow(0.5, t * 10)
        //   );
        // }

        // Camera move speed
        function customEasing(t) {
          return 1 - Math.pow(1 - t, 3);
        }

        document
          .getElementById("bounceParis13")
          .addEventListener("click", () => {
            view
              .goTo(
                {
                  position: {
                    x: 2.3557,
                    y: 48.8315,
                    z: 5000,
                    spatialReference: {
                      wkid: 4326
                    }
                  },
                  heading: 0,
                  tilt: 0,
                },
                {
                  speedFactor: 0.3,
                  easing: customEasing
                }
              )
              .catch(catchAbortError);
          });

        document
          .getElementById("bounceEiffelTower3D")
          .addEventListener("click", () => {
            view
              .goTo(
                {
                  //   position: {
                  //     x: 2.2930,
                  //     y: 48.8450,
                  //     z: 550.88439,
                  //     spatialReference: {
                  //       wkid: 4326
                  //     }
                  //   },
                  //   heading: 20,
                  //   tilt: 73
                  // }
                  position: {
                    x: 2.3077897,
                    y: 48.8498227,
                    z: 140
                  },
                  heading: -45,
                  tilt: 90
                },
                {
                  speedFactor: 0.3,
                  easing: customEasing
                }
              )
              .catch(catchAbortError);
          });


        document
          .getElementById("bounceEiffelTower2D")
          .addEventListener("click", () => {
            view
              .goTo(
                {
                  position: {
                    x: 2.294481,
                    y: 48.858370,
                    z: 3000.88439,
                    spatialReference: {
                      wkid: 4326
                    }
                  },
                  heading: 10,
                  tilt: 0
                },
                {
                  speedFactor: 0.3,
                  easing: customEasing
                }
              )
              .catch(catchAbortError);
          });

        // Camera log
        console.log('Position de la caméra x :', view.camera.position.x);
        console.log('Position de la caméra y:', view.camera.position.y);
        console.log('Position de la caméra z:', view.camera.position.z);
        console.log('Heading de la caméra :', view.camera.heading);
        console.log('Inclinaison de la caméra :', view.camera.tilt);


        // Camera position 2D
        document.getElementById("2D_camera").addEventListener("click", (event) => {
          view.camera = {
            position: [2.294481, 48.858370, 3000.88439],
            heading: 10,
            tilt: 0
          }
        });
        // Camera position 3D
        document.getElementById("3D_camera").addEventListener("click", (event) => {
          view.camera = {
            position: [2.2930, 48.8450, 550.88439],
            heading: 20,
            tilt: 73
          }
        });


        let type = "cartographic";
        // document.getElementById("footprint").addEventListener("click", (event) => {
        //   footprintBuildings.visible = true;
        //   extrudedBuildings.visible = false;
        // });
        // document.getElementById("extruded").addEventListener("click", (event) => {
        //   footprintBuildings.visible = false;
        //   extrudedBuildings.visible = true;
        // });

      }
      );






    });







  }, []);


  console.log(lstFeatures.length)
  /**
        *  Save buttons
        **/

  // Usestate : Check of username authenticated
  const [usernameAuthenticated, setUsernameAuthenticated] = useState("");
  const [selectedItemsAuthenticated, setSelectedItemsAuthenticated] = useState([]);
  // Button

  // Function: SaveSelectedItems

  let selectedItems = [];

  const saveSelectedItems = async () => {

    console.log("lstfeatures : " + lstFeatures)
    for (let i = 0; i < lstFeatures.length; i++) {
      console.log("Stringify" + JSON.stringify(lstFeatures[i].feature.attributes.siretNumber));
      const siretNumber = lstFeatures[i].feature.attributes.siretNumber;
      selectedItems.push(siretNumber);
      console.log("Selected Items " + selectedItems)
    }
    setSelectedItemsAuthenticated(selectedItems);

  }

  //Function: parseJwt
  function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  // Function: Fetch Username from token
  const fetchUsername = async () => {
    const token = sessionStorage.getItem('accessToken');
    const decodedToken = parseJwt(token);
    console.log(decodedToken)
    const username = decodedToken.sub
    setUsernameAuthenticated(username)
    console.log(usernameAuthenticated)
  };

  // Function: Save selected Companies

  const saveInformation = async () => {

    // await fetchUsername();

    let wsUrl = `${import.meta.env.VITE_REACT_APP_BACK_SPRING_COMPANY_SELECTION_ENDPOINT}`;

    try {
      //   const params = new URLSearchParams();
      //   params.append('username', usernameAuthenticated);
      console.log("usernameAuthenticated = " + usernameAuthenticated)
      const response = await fetch(wsUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`
        },

        body: JSON.stringify({
          username: usernameAuthenticated,
          selectedCompanies: selectedItemsAuthenticated
        })
      });
      console.log(selectedItemsAuthenticated)

      if (response.status == 200) {
        console.log("Ajout ok à la BDD : ");

      } else {
        let text = await response.text();
        console.log("error response text : " + text);
      }
    } catch (ex) {
      console.log("ex : " + ex);

    }

  };


  // Click event handler for the save button
  const handleSaveButtonClick = async () => {
    console.log("clicked");
    await saveSelectedItems();
    await fetchUsername();

  };


  // UseEffect : Look for changing of `usernameAuthenticated`
  useEffect(() => {
    if (usernameAuthenticated !== "") {
      // `usernameAuthenticated` a été mis à jour, vous pouvez maintenant appeler `saveInformation`
      saveInformation();
    }
  }, [usernameAuthenticated]);


  // Créez les données du graphique

  const [revenue_global_chart, setRevenue_global_chart] = useState("");
  const [companies_count_under_500K, setCompanies_count_under_500k] = useState("");
  const [companies_count_over_500K, setCompanies_count_over_500k] = useState("");
  const [chartDisplay, setChartDisplay] = useState("flex");

  const dataChart = {
    labels: ["Revenue < 500K€", "Revenue >= 500K€"],
    datasets: [
      {
        label: 'number of companies',
        data: [companies_count_under_500K, companies_count_over_500K],
        backgroundColor: ['rgba(255, 99, 132, 0.8)', 'rgba(54, 162, 235, 0.8)', 'rgba(75, 192, 192, 0.8)'],
        borderColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(75, 192, 192, 1)'],
        borderWidth: 1
      }
    ]
  };

  const dataPolar = {
    labels: ["Zone revenue"],
    datasets: [
      {
        label: 'zone revenue',
        data: [revenue_global_chart],
        backgroundColor: ['rgba(75, 192, 192, 0.8)'],
        borderColor: ['rgba(75, 192, 192, 1)'],
        borderWidth: 1
      }
    ]
  };
  // Configurez les options du graphique
  const optionsChart = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        type: 'linear',
        // Autres options de configuration de l'échelle
      }
    },
    plugins: {
      title: {
        display: true,
        text: "Number of companies", // Utilisez le titre du graphique de la variable d'état
        font: {
          size: 16
        }
      }
    }
  };

  const optionsPolar = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        type: 'linear',
        // Autres options de configuration de l'échelle
      }
    },
    plugins: {
      title: {
        display: true,
        text: "Zone revenue", // Utilisez le titre du graphique de la variable d'état
        font: {
          size: 16
        }
      }
    }
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    RadialLinearScale,
    ArcElement
  );




  return (
    <>

      <section ref={previousSectionRef}>

        <div className="container">
          <div id="viewDiv" style={{ height: "93vh", width: "100%" }} >

            <div id="buttons mapbuttons" style={{ padding: "1px", position: "absolute", top: "93vh", left: "50%", transform: "translateX(-50%)", display: "flex", justifyContent: "center" }}>
              <button id="tent" className="esri-button esri-button--half" style={{ display: "none" }}>Tent</button>
              <button id="canoe" className="esri-button esri-button--half" style={{ display: "none" }}>Canoe</button>
              <button id="2D_camera" className="esri-button esri-button--half"
                style={{
                  color: "#333",
                  backgroundColor: "#fff",
                  transition: "background-color 0.3s",
                  display: "none"
                }}
                onMouseEnter={(event) => {
                  event.target.style.backgroundColor = '#7DA7A3';
                }}
                onMouseLeave={(event) => {
                  event.target.style.backgroundColor = "#fff";
                }}
              >2D camera</button>

              <button id="3D_camera" className="esri-button esri-button--half" style={{
                color: "#333",
                backgroundColor: "#fff",
                transition: "background-color 0.3s",
                display: "none"
              }}
                onMouseEnter={(event) => {
                  event.target.style.backgroundColor = '#7DA7A3';
                }}
                onMouseLeave={(event) => {
                  event.target.style.backgroundColor = "#fff";
                }}>3D camera</button>


              <button
                className="esri-button esri-button--half" style={{
                  color: "#333",
                  backgroundColor: "#fff",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(event) => {
                  event.target.style.backgroundColor = '#7DA7A3';
                }}
                onMouseLeave={(event) => {
                  event.target.style.backgroundColor = "#fff";
                }}
                id="selectButton"
                title="Query by polygon"
              >Query polygon</button>
              <button
                className="esri-button esri-button--half" style={{
                  color: "#333",
                  backgroundColor: "#fff",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(event) => {
                  event.target.style.backgroundColor = '#7DA7A3';
                }}
                onMouseLeave={(event) => {
                  event.target.style.backgroundColor = "#fff";
                }}
                id="clearButton"
                title="Query by polygon"
              >Clear polygon</button>

              <button id="bounceParis13" className="esri-button esri-button--half" style={{
                color: "#333",
                backgroundColor: "#fff",
                transition: "background-color 0.3s",
              }}
                onMouseEnter={(event) => {
                  event.target.style.backgroundColor = '#7DA7A3';
                }}
                onMouseLeave={(event) => {
                  event.target.style.backgroundColor = "#fff";
                }}>Bounce to Paris 13th</button>

              <button id="bounceEiffelTower3D" className="esri-button esri-button--half" style={{
                color: "#333",
                backgroundColor: "#fff",
                transition: "background-color 0.3s",
              }}
                onMouseEnter={(event) => {
                  event.target.style.backgroundColor = '#7DA7A3';
                }}
                onMouseLeave={(event) => {
                  event.target.style.backgroundColor = "#fff";
                }}>Bounce Eiffel Tower 3D</button>

              <button id="bounceEiffelTower2D" className="esri-button esri-button--half"
                style={{
                  color: "#333",
                  backgroundColor: "#fff",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(event) => {
                  event.target.style.backgroundColor = '#7DA7A3';
                }}
                onMouseLeave={(event) => {
                  event.target.style.backgroundColor = "#fff";
                }}>Bounce Eiffel Tower 2D</button>

              <button onClick={handleNextSection} className="esri-button esri-button--half" style={{
                color: "#333",
                backgroundColor: "#fff",
                transition: "background-color 0.3s",
              }}
                onMouseEnter={(event) => {
                  event.target.style.backgroundColor = '#7DA7A3';
                }}
                onMouseLeave={(event) => {
                  event.target.style.backgroundColor = "#fff";
                }}>Go to Table</button>
            </div>

            <div className="chart-container" style={{ display: chartDisplay, flexDirection: 'column', zIndex: "2000", position: "absolute", bottom: "10%", right: "1%", }}>
              <div className="chart-item" >
                <div >
                  <Bar data={dataChart} options={optionsChart} />
                </div>
              </div>
              <div className="chart-item" >
                <div>
                  <PolarArea data={dataPolar} options={optionsPolar} />
                </div>
              </div>
            </div>

          </div>
        </div>



      </section>

      <section ref={nextSectionRef}>
        <div id="tableDiv" style={{ height: "100vh", width: "100%" }}>
          <div style={{ display: "flex" }}>
            <button id="gotomapButton" onClick={handlePreviousSection}
              style={{
                position: "relative",
                top: "10px",
                right: "10px",
                backgroundColor: "#f5f5f5",
                color: "#333",
                border: "1px solid #333",
                padding: "6px 12px",
                borderRadius: "4px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
                marginRight: "10px", // Ajouter de la marge à droite du bouton
                marginLeft: "10px", // Ajouter de la marge à droite du bouton
                marginBottom: "10px", // Ajouter de la marge en bas du bouton
              }}
            >Go to map</button>

            <button id="saveButton" onClick={handleSaveButtonClick} style={{
              position: "relative",
              top: "10px",
              right: "10px",
              backgroundColor: "#f5f5f5",
              color: "#333",
              border: "1px solid #333",
              padding: "6px 12px",
              borderRadius: "4px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              marginRight: "10px", // Ajouter de la marge à droite du bouton
              marginLeft: "10px", // Ajouter de la marge à droite du bouton
              marginBottom: "10px", // Ajouter de la marge en bas du bouton
            }}>Save Selected</button>
          </div>
        </div>
      </section>



    </>
  )
};

export default Map;
